// extracted by mini-css-extract-plugin
export default {"inputPhone":"InputPhone_inputPhone__+GSzX","inputLabel":"InputPhone_inputLabel__jLbtM","inputError":"InputPhone_inputError__jG6bj"};